// extracted by mini-css-extract-plugin
export default {"text":"YH0DslXc00zPBEup6mZv"};